module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalBase', {
    staticClass: "save-as-modal",
    attrs: {
      "title": "Save Floorplan As"
    },
    on: {
      "close": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "grid-container"
  }, [(_vm.enable3DPreview) ? _c('div', {
    staticClass: "export-label"
  }, [_vm._v("Export Format:")]) : _vm._e(), _vm._v(" "), (_vm.enable3DPreview) ? _c('div', {
    staticClass: "export-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exportType),
      expression: "exportType"
    }],
    attrs: {
      "type": "radio",
      "id": "export-input-floorspace",
      "value": "floorspace"
    },
    domProps: {
      "checked": _vm._q(_vm.exportType, "floorspace")
    },
    on: {
      "change": function($event) {
        _vm.exportType = "floorspace"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "export-input-floorspace"
    }
  }, [_vm._v("Floorspace.js")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exportType),
      expression: "exportType"
    }],
    attrs: {
      "type": "radio",
      "id": "export-input-threejs",
      "value": "threejs"
    },
    domProps: {
      "checked": _vm._q(_vm.exportType, "threejs")
    },
    on: {
      "change": function($event) {
        _vm.exportType = "threejs"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "export-input-threejs"
    }
  }, [_vm._v("ThreeJS")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "filename-label"
  }, [_vm._v("Filename:")]), _vm._v(" "), _c('div', {
    staticClass: "filename-input"
  }, [_c('input', {
    ref: "downloadName",
    attrs: {
      "type": "text",
      "id": "download-name",
      "spellcheck": "false"
    },
    domProps: {
      "value": _vm.floorplan
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.downloadFile($event)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "download-button",
    on: {
      "click": _vm.downloadFile
    }
  }, [_vm._v("Download")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3c3490f3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modals/SaveAsModal.vue
// module id = 744
// module chunks = 2